import React from "react";
import { Button } from "@jds/core";

export default function AddButton(props) {
  return <Button label={props?.label || "Add"} iconLeft={"IcAdd"} {...props} />;
}
